

export const keywordOptions = [
    { label: "Startup", value: "Startup" },
    { label: "Marketing", value: "Marketing" },
    { label: "Audience building", value: "Audience building" },
    { label: "Seo", value: "Seo" },
    { label: "Digital Marketing", value: "Digital Marketing" },
    { label: "Copywriting", value: "Copywriting" },
    { label: "Web Design", value: "Web Design" },
    { label: "Personal Branding", value: "Personal Branding" },
    { label: "Entrepreneurship", value: "Entrepreneurship" },
    { label: "Productivity", value: "Productivity" },
];